export function scrollPageToReviews(reviewListElement: HTMLElement) {
    window.scrollTo({
        behavior: 'smooth',
        top: getScrollPosition(reviewListElement),
    });
}

function getScrollPosition(reviewListElement: HTMLElement) {
    const mobileBreakpoint = 768;
    const headerHeight = 56;
    const isOnDesktop = window.innerWidth > mobileBreakpoint;
    return isOnDesktop ? reviewListElement.offsetTop : reviewListElement.offsetTop + headerHeight;
}
